module.exports = "/images/new-job.png?6bd0711aa9c5c74619cc1df6ba279afc";